import { User } from "../users/user.model";

export class Reshuffle {
   public Loan: PipelineLoanDto;
   public Users: Array<User>;
}

export class PipelineLoanDto {
    public LoanGuid:string;
    public fields: any;
}

export class ReshuffleResponse {
    public assignedSuccessfully: boolean;
    public messages: string[];
}

export class LoanList {
    public LoanList: string[];
    public AssignedDate: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-assignment-reshuffle/reshuffle.ts